// Ported from ../complete-inverter-web frontend/src/components/BgPhotos.jsx.
// Fixed full-viewport photo layer behind the page. The photo does not scroll;
// it crossfades to the topic of whichever [data-bg] zone currently crosses
// the middle of the screen. A theme-aware veil keeps text readable
// (.bg-photos rules in index.css). Assets + credits: public/assets/bg/.
import { useEffect, useState } from "react";

// Three topic zones: intelligent battery energy (top of page), the actual
// device/hardware section, and the plans/pricing block.
const TOPICS = [
  { key: "energy", src: "/assets/bg/solar.webp" },
  { key: "hardware", src: "/assets/bg/tech.webp" },
  { key: "plans", src: "/assets/bg/alps.webp" },
] as const;

export function BgPhotos() {
  const [active, setActive] = useState<string>("energy");

  useEffect(() => {
    const zones = Array.from(document.querySelectorAll<HTMLElement>("[data-bg]"));
    if (!zones.length) return undefined;
    let raf = 0;

    function update() {
      raf = 0;
      const mid = window.innerHeight / 2;
      // deepest zone whose top has crossed the middle of the screen
      let current = zones[0].dataset.bg as string;
      for (const zone of zones) {
        if (zone.getBoundingClientRect().top <= mid) current = zone.dataset.bg as string;
        else break;
      }
      setActive((prev) => (prev === current ? prev : current));
    }

    function schedule() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="bg-photos" aria-hidden="true">
      {TOPICS.map((t) => (
        <div
          key={t.key}
          className={`bg-photo${active === t.key ? " bg-photo--active" : ""}`}
          style={{ backgroundImage: `url(${t.src})` }}
        />
      ))}
    </div>
  );
}
